var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.0415C29.3116 24.0415 30.375 25.1048 30.375 26.4165V42.2498C30.375 43.5615 29.3116 44.6248 28 44.6248C26.6883 44.6248 25.625 43.5615 25.625 42.2498V26.4165C25.625 25.1048 26.6883 24.0415 28 24.0415Z",
    fill: "#E0CD1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.4998C29.7489 18.4998 31.1666 17.0821 31.1666 15.3332C31.1666 13.5843 29.7489 12.1665 28 12.1665C26.2511 12.1665 24.8333 13.5843 24.8333 15.3332C24.8333 17.0821 26.2511 18.4998 28 18.4998Z",
    fill: "#E0CD1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.291626 27.9998C0.291626 12.6969 12.6971 0.291504 28 0.291504C43.3028 0.291504 55.7083 12.6969 55.7083 27.9998C55.7083 43.3027 43.3028 55.7082 28 55.7082C12.6971 55.7082 0.291626 43.3027 0.291626 27.9998ZM28 5.0415C15.3204 5.0415 5.04163 15.3203 5.04163 27.9998C5.04163 40.6794 15.3204 50.9582 28 50.9582C40.6795 50.9582 50.9583 40.6794 50.9583 27.9998C50.9583 15.3203 40.6795 5.0415 28 5.0415Z",
    fill: "#E0CD1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.d398ac8b37d2ae5078ba8e826b27b8e9.svg";
export { ForwardRef as ReactComponent };